// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/companion/components/CompanionPanel.module.css';
import CompanionSessionStore from '@app/features/companion/state/CompanionSessionStore';
import * as VoiceStateCommands from '@app/features/devtools/commands/VoiceStateCommands';
import {Button} from '@app/features/ui/button/Button';
import {AudioLevelMeter} from '@app/features/user/components/modals/tabs/components/AudioLevelMeter';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {MicrophoneIcon, MicrophoneSlashIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

export const CompanionAudioControls = observer(function CompanionAudioControls() {
	const {i18n} = useLingui();
	const muted = CompanionSessionStore.inputMuted;
	const paused = CompanionSessionStore.session?.status === 'paused';
	const active = CompanionSessionStore.hasActiveSession;
	return (
		<div className={styles.audioControls} data-flx="companion.companion-audio-controls.audio-controls">
			<div className={styles.inputRow} data-flx="companion.companion-audio-controls.input-row">
				<Button
					square
					small
					variant="secondary"
					aria-pressed={muted}
					aria-label={i18n._(muted ? msg({message: 'Unmute microphone'}) : msg({message: 'Mute microphone'}))}
					icon={
						muted ? (
							<MicrophoneSlashIcon size={18} data-flx="companion.companion-audio-controls.microphone-slash-icon" />
						) : (
							<MicrophoneIcon size={18} data-flx="companion.companion-audio-controls.microphone-icon" />
						)
					}
					onClick={() => void VoiceStateCommands.toggleSelfMute(null)}
					data-flx="companion.companion-audio-controls.microphone-toggle"
				/>
				<AudioLevelMeter
					level={!active || muted || paused ? 0 : CompanionSessionStore.inputLevel}
					className={styles.inputMeter}
					role="meter"
					aria-valuemin={0}
					aria-valuemax={1}
					aria-valuenow={!active || muted || paused ? 0 : CompanionSessionStore.inputLevel}
					aria-label={i18n._(msg({message: 'Microphone input level'}))}
					data-flx="companion.companion-audio-controls.input-meter"
				/>
				<span className={styles.sceneHint} data-flx="companion.companion-audio-controls.scene-hint">
					{i18n._(
						paused
							? msg({message: 'Paused'})
							: muted
								? msg({message: 'Microphone muted'})
								: active
									? msg({message: 'Microphone on'})
									: msg({message: 'Not capturing'}),
					)}
				</span>
			</div>
		</div>
	);
});
